import BaseHotspot from "./BaseHotspot";
import TWEEN from "@tweenjs/tween.js";

/**
 * Type of hotspot where the action is to transition to another image
 * by moving the scene upward
 */
export default class ElevateUpHotspot extends BaseHotspot {
  /**
   * Initialises a elevate-up hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'elevate-up',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "elevate-up.png");

    this._config = config;
  }

  /**
   * Event fired when clicked
   *
   * @param {MouseEvent} event
   */
  action(event) {
    this.changeToSpinner();
    let trigger = { position: { x: 0, y: 600, z: 0 } };

    if (
      this.player._options.setUIVisibility &&
      this.player.viewerMode !== "stereo" &&
      !this.player.renderer.xr.enabled &&
      this.player.viewerMode !== "device"
    ) {
      //Change hide the UI, then show it after some time
      this.player._options.setUIVisibility(false);

      clearTimeout(this.player._mouseTimeoutLink);
      this.player._mouseTimeoutLink = setTimeout(() => {
        this.player.dragging = false;
        this.player._options.setUIVisibility(true);
        this.player.sceneManager.activeScene().onMouseStopDrag(event);
      }, 2500);
    }

    return this.player.transitionTo(
      this._config.options.id,
      trigger,
      "no-parallax",
      () => {
        this._isLoaded = true;
        const opacity = { value: 1 };
        const opacityTween = new TWEEN.Tween(opacity).to(
          {
            value: 0,
          },
          100,
        );
        opacityTween.onUpdate(() => {
          this.setOpacity(opacity.value);
        });
        opacityTween.start();
      },
    );
  }
}
